import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject;
import React, { useContext, useEffect, useRef } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { EditorView } from '@codemirror/view';
import * as themes from '@uiw/codemirror-themes-all';
import { langs } from '@uiw/codemirror-extensions-langs';
import styled from 'styled-components';
import { Container, ContainerPadding, EidtorContainer } from "../Container.js";
import { Context } from "../../store/content.js";
import { ContextSetting } from "../../store/setting.js";
import { showHeader } from "./showPanel.js";
import { windowsStyle } from "./windowsStyle.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var basicSetup = {
  foldGutter: false
};
var DragWidth = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  width: 5px;\n  height: 100%;\n  position: absolute;\n  z-index: 999;\n  right: -3px;\n  cursor: ew-resize;\n  user-select: none;\n  background-color: #57b5f9;\n  opacity: 0;\n  &:hover {\n    opacity: 0.4;\n  }\n"])));
export default function EditorContainer() {
  var $dom = useRef(null);
  var $container = useRef(null);
  var startX = useRef(0);
  var startWidth = useRef(0);
  var {
    theme,
    imageName,
    code,
    lang,
    setCode,
    setDomImage
  } = useContext(Context);
  var {
    state,
    dispatch
  } = useContext(ContextSetting);
  var {
    windowStyle,
    offsetX,
    offsetY,
    blurRadius,
    spreadRadius,
    color,
    lineNumbers,
    lineHighlight,
    fontSize,
    enableShadow,
    padding,
    width,
    borderRadius
  } = state;
  if (typeof basicSetup === 'object') {
    basicSetup.lineNumbers = lineNumbers;
  }
  var defaultStyle = EditorView.theme({
    '&.cm-editor': {
      borderRadius: borderRadius + "px",
      padding: '6px',
      fontSize: fontSize + "px"
    },
    '.cm-gutters': {
      borderRight: '0',
      backgroundColor: 'transparent !important'
    },
    '.cm-activeLine, .cm-activeLineGutter': lineHighlight ? {} : {
      backgroundColor: 'transparent !important'
    },
    '.cm-line': {
      paddingRight: '5px'
    },
    '.cm-panels': {
      position: 'relative !important',
      backgroundColor: 'transparent !important'
    },
    '.cm-scroller': {
      padding: '5px',
      fontFamily: 'source-code-pro,Menlo,Monaco,Consolas,Courier New,monospace'
    },
    '&.cm-editor.cm-focused': {
      outline: 0
    }
  });
  var extensions = [defaultStyle, windowsStyle, showHeader({
    style: windowStyle,
    title: imageName,
    disableTitle: state.disableTitle
  })];
  if (langs[lang]) {
    extensions.push(langs[lang]());
  }
  if (width) {
    extensions.push(EditorView.lineWrapping);
  }
  useEffect(() => {
    if ($dom.current) {
      setDomImage($dom.current);
    }
  }, [$dom]);
  var handleChange = value => {
    setCode(value);
  };
  var handleMouseDown = ev => {
    var _$container$current;
    startX.current = ev.clientX;
    startWidth.current = ((_$container$current = $container.current) == null ? void 0 : _$container$current.clientWidth) || 0;
    window.addEventListener('mousemove', onDragging, false);
    window.addEventListener('mouseup', onDragEnd, false);
  };
  var onDragging = ev => {
    var newWidth = ev.clientX - startX.current;
    var currentWdith = startWidth.current + newWidth;
    if (currentWdith > 250) {
      dispatch({
        width: String(currentWdith)
      });
    }
  };
  var onDragEnd = ev => {
    window.removeEventListener('mousemove', onDragging, false);
    window.removeEventListener('mouseup', onDragEnd, false);
  };
  return /*#__PURE__*/_jsx(EidtorContainer, {
    children: /*#__PURE__*/_jsx(ContainerPadding, {
      ref: $dom,
      padding: padding,
      children: /*#__PURE__*/_jsxs(Container, {
        ref: $container,
        enableShadow: enableShadow,
        borderRadius: borderRadius,
        offsetX: offsetX,
        offsetY: offsetY,
        blurRadius: blurRadius,
        spreadRadius: spreadRadius,
        shadowColor: color,
        children: [/*#__PURE__*/_jsx(DragWidth, {
          onMouseDown: handleMouseDown
        }), /*#__PURE__*/_jsx(CodeMirror, {
          theme: themes[theme],
          width: width + "px",
          basicSetup: basicSetup,
          placeholder: "Please enter your code",
          extensions: extensions,
          value: code,
          onChange: handleChange
        })]
      })
    })
  });
}